import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { IconButton } from "@mui/material";
import VisibilityIcon from "@material-ui/icons/Visibility";
 import { getDocFormsToAssign } from "../../../../services/templateV2Service";
import { useNavigate } from "react-router-dom";
import { BaseDataTable } from "../../../../components/common/BaseDataTable";
import { colors } from "../../../../components/theme";
import TableSkeletonLoader from '../TableSkeletonLoader/TableSkeletonLoader';
import moment from "moment-timezone";

const useStyles = makeStyles((theme) => ({
  container: {
    width: "100%",
    height: "100%",
    backgroundColor: "#fff",
    display: "inline-block",
    padding: "10px",
    position: "relative",
    overflowY: "auto",
    borderRadius: "8px",
  },
  actionText: {
    fontSize: "14px",
    marginLeft: "4px",
    color: colors.blue,
  },
}));

export default function AssignedView({ setLoading, onAssignedCountChange }) {
	const classes = useStyles();
	const [assignedForms, setAssignedForms] = useState([]);
	const [isLoadingData, setIsLoadingData] = useState(true);

	useEffect(() => {
		console.log("assignedForms");
		const fetchData = async () => {
			try {
				setIsLoadingData(true);
				setLoading(true, "Loading assigned forms...");
				const res = await getDocFormsToAssign();
				setAssignedForms(res.data);
				// Update the assigned count when data is fetched
				if (onAssignedCountChange) {
					onAssignedCountChange(res.data.length);
				}
			} catch (error) {
				console.error("Error fetching assigned forms:", error);
			} finally {
				setIsLoadingData(false);
				setLoading(false);
			}
		};
		fetchData();
	}, [onAssignedCountChange]); // eslint-disable-line react-hooks/exhaustive-deps
	const navigate = useNavigate();

  const toComplete = (row) => {
    console.log(row);
    setLoading(true, "Loading...");
    navigate(`/docFormFiller/${row.templateId}/${row.id}`);
  };

  const columns = [
    {
      field: "requestedAt",
      headerName: "Form Request Date",
      flex: 1,
      headerClassName: "MuiTableHead-root",
      valueFormatter: (params) =>
        params.value ? moment(params.value).format("MM/DD/YYYY HH:mm") : "N/A",
    },
    {
      field: "templateName",
      headerName: "Form Name",
      headerClassName: "MuiTableHead-root",
      flex: 1.5,
    },
    {
      field: "completed",
      headerName: "Status",
      headerClassName: "MuiTableHead-root",
      flex: 0.8,
      valueGetter: (params) => {
        return params.row.completed === 0 ? "Incomplete" : "Complete";
      },
    },
    {
      field: "actions",
      headerName: "Action",
      headerClassName: "MuiTableHead-root",
      flex: 0.8,
      renderCell: (params) => {
        return (
          <div
            style={{ display: "flex", justifyContent: "center", width: "100%" }}
          >
            <IconButton
              color="primary"
              title="To Complete"
              onClick={() => toComplete(params.row)}
            >
              <VisibilityIcon color="primary" />
              <span className={classes.actionText}>To Complete</span>
            </IconButton>
          </div>
        );
      },
    },
  ];

	return (
		<div className={classes.container}>
			{isLoadingData ? (
				<TableSkeletonLoader rows={8} columns={4} />
			) : (
				<BaseDataTable
					data={assignedForms.map((form) => ({ ...form, id: form.id }))}
					columns={columns}
					onRowClick={(params) => toComplete(params.row)}
					pageSize={10}
					rowsPerPageOptions={[10, 25, 50]}
					disableSelectionOnClick
					disableColumnSelector
					disableColumnMenu
					hideFooterSelectedRowCount
					autoHeight
				/>
			)}
		</div>
	);
}
